import React from "react";
import { Grid, Stack, TextField, ToggleButton } from "@mui/material";
import styled from "styled-components";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { format } from "date-fns";

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    margin: theme.spacing(1.5),
    border: 0,
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.background.toggleButtonUnselected,
    "&.Mui-disabled": {
        border: 0,
    },
    "&.Mui-selected": {
        border: 0,
        color: theme.palette.background.default,
        backgroundColor: theme.palette.primary.main,
    },
    "&:not(:first-of-type)": {
        borderRadius: "34px",
        minWidth: "46px",
    },
    "&:first-of-type": {
        borderRadius: "34px",
        minWidth: "46px",
    },
}));

const ItemTitle = styled.span`
    font-size: 14px;
    font-weight: 400;
    min-width: 6rem;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const WorkingHoursInfo = ({ workingDays, setChanges }) => {
    const [sunday, setSunday] = React.useState({
        from: (workingDays && workingDays.sunday && workingDays.sunday.from) || "09:00",
        to: (workingDays && workingDays.sunday && workingDays.sunday.to) || "17:00",
    });
    const [monday, setMonday] = React.useState({
        from: (workingDays && workingDays.monday && workingDays.monday.from) || "09:00",
        to: (workingDays && workingDays.monday && workingDays.monday.to) || "17:00",
    });
    const [tuesday, setTuesday] = React.useState({
        from: (workingDays && workingDays.tuesday && workingDays.tuesday.from) || "09:00",
        to: (workingDays && workingDays.tuesday && workingDays.tuesday.to) || "17:00",
    });
    const [wednesday, setWednesday] = React.useState({
        from: (workingDays && workingDays.wednesday && workingDays.wednesday.from) || "09:00",
        to: (workingDays && workingDays.wednesday && workingDays.wednesday.to) || "17:00",
    });
    const [thursday, setThursday] = React.useState({
        from: (workingDays && workingDays.thursday && workingDays.thursday.from) || "09:00",
        to: (workingDays && workingDays.thursday && workingDays.thursday.to) || "17:00",
    });
    const [friday, setFriday] = React.useState({
        from: (workingDays && workingDays.friday && workingDays.friday.from) || "09:00",
        to: (workingDays && workingDays.friday && workingDays.friday.to) || "17:00",
    });
    const [saturday, setSaturday] = React.useState({
        from: (workingDays && workingDays.saturday && workingDays.saturday.from) || "09:00",
        to: (workingDays && workingDays.saturday && workingDays.saturday.to) || "17:00",
    });

    const [sundayWork, setSundayWork] = React.useState(workingDays && !!workingDays.sunday);
    const [mondayWork, setMondayWork] = React.useState(workingDays && !!workingDays.monday);
    const [tuesdayWork, setTuesdayWork] = React.useState(workingDays && !!workingDays.tuesday);
    const [wednesdayWork, setWednesdayWork] = React.useState(
        workingDays && !!workingDays.wednesday
    );
    const [thursdayWork, setThursdayWork] = React.useState(workingDays && !!workingDays.thursday);
    const [fridayWork, setFridayWork] = React.useState(workingDays && !!workingDays.friday);
    const [saturdayWork, setSaturdayWork] = React.useState(workingDays && !!workingDays.saturday);

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    return (
        <Grid container direction="column" spacing={3} mt={1}>
            <Grid item>
                <StyledToggleButton
                    selected={sundayWork}
                    onClick={() => {
                        setSundayWork(!sundayWork);
                        if (sundayWork === true) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                sunday: {
                                    from: undefined,
                                    to: undefined,
                                },
                            }));
                        }
                        if (sundayWork === false) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                sunday,
                            }));
                        }
                    }}
                    value="sunday"
                >
                    S
                </StyledToggleButton>
                <StyledToggleButton
                    selected={mondayWork}
                    onClick={() => {
                        setMondayWork(!mondayWork);
                        if (mondayWork === true) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                monday: {
                                    from: undefined,
                                    to: undefined,
                                },
                            }));
                        }
                        if (mondayWork === false) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                monday,
                            }));
                        }
                    }}
                    value="monday"
                >
                    M
                </StyledToggleButton>
                <StyledToggleButton
                    selected={tuesdayWork}
                    onClick={() => {
                        setTuesdayWork(!tuesdayWork);
                        if (tuesdayWork === true) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                tuesday: {
                                    from: undefined,
                                    to: undefined,
                                },
                            }));
                        }
                        if (tuesdayWork === false) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                tuesday,
                            }));
                        }
                    }}
                    value="tuesday"
                >
                    T
                </StyledToggleButton>
                <StyledToggleButton
                    selected={wednesdayWork}
                    onClick={() => {
                        setWednesdayWork(!wednesdayWork);
                        if (wednesdayWork === true) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                wednesday: {
                                    from: undefined,
                                    to: undefined,
                                },
                            }));
                        }
                        if (wednesdayWork === false) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                wednesday,
                            }));
                        }
                    }}
                    value="wednesday"
                >
                    W
                </StyledToggleButton>
                <StyledToggleButton
                    selected={thursdayWork}
                    onClick={() => {
                        setThursdayWork(!thursdayWork);
                        if (thursdayWork === true) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                thursday: {
                                    from: undefined,
                                    to: undefined,
                                },
                            }));
                        }
                        if (thursdayWork === false) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                thursday,
                            }));
                        }
                    }}
                    value="thursday"
                >
                    T
                </StyledToggleButton>
                <StyledToggleButton
                    selected={fridayWork}
                    onClick={() => {
                        setFridayWork(!fridayWork);
                        if (fridayWork === true) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                friday: {
                                    from: undefined,
                                    to: undefined,
                                },
                            }));
                        }
                        if (fridayWork === false) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                friday,
                            }));
                        }
                    }}
                    value="friday"
                >
                    F
                </StyledToggleButton>
                <StyledToggleButton
                    selected={saturdayWork}
                    onClick={() => {
                        setSaturdayWork(!saturdayWork);
                        if (saturdayWork === true) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                saturday: {
                                    from: undefined,
                                    to: undefined,
                                },
                            }));
                        }
                        if (saturdayWork === false) {
                            setChanges((prevState) => ({
                                ...prevState,
                                enabled: true,
                                saturday,
                            }));
                        }
                    }}
                    value="saturday"
                >
                    S
                </StyledToggleButton>
            </Grid>
            <Grid item>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    {sundayWork && (
                        <Stack direction="row" alignItems="center" spacing={2} pt={1} pb={1}>
                            <ItemTitle>Sunday</ItemTitle>
                            <TimePicker
                                label="From"
                                value={new Date(`01/01/2017 ${sunday.from}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setSunday((prevState) => ({
                                        ...prevState,
                                        from: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        sunday: {
                                            from: format(new Date(newValue), "HH:mm"),
                                            to: sunday.to,
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                            <TimePicker
                                label="To"
                                value={new Date(`01/01/2017 ${sunday.to}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setSunday((prevState) => ({
                                        ...prevState,
                                        to: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        sunday: {
                                            from: sunday.from,
                                            to: format(new Date(newValue), "HH:mm"),
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                        </Stack>
                    )}
                    {mondayWork && (
                        <Stack direction="row" alignItems="center" spacing={2} pt={1} pb={1}>
                            <ItemTitle>Monday</ItemTitle>
                            <TimePicker
                                label="From"
                                value={new Date(`01/01/2017 ${monday.from}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setMonday((prevState) => ({
                                        ...prevState,
                                        from: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        sunday: {
                                            from: format(new Date(newValue), "HH:mm"),
                                            to: monday.to,
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                            <TimePicker
                                label="To"
                                value={new Date(`01/01/2017 ${monday.to}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setMonday((prevState) => ({
                                        ...prevState,
                                        to: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        monday: {
                                            from: monday.from,
                                            to: format(new Date(newValue), "HH:mm"),
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                        </Stack>
                    )}
                    {tuesdayWork && (
                        <Stack direction="row" alignItems="center" spacing={2} pt={1} pb={1}>
                            <ItemTitle>Tuesday</ItemTitle>
                            <TimePicker
                                label="From"
                                value={new Date(`01/01/2017 ${tuesday.from}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setTuesday((prevState) => ({
                                        ...prevState,
                                        from: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        tuesday: {
                                            from: format(new Date(newValue), "HH:mm"),
                                            to: tuesday.to,
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                            <TimePicker
                                label="To"
                                value={new Date(`01/01/2017 ${tuesday.to}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setTuesday((prevState) => ({
                                        ...prevState,
                                        to: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        tuesday: {
                                            from: tuesday.from,
                                            to: format(new Date(newValue), "HH:mm"),
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                        </Stack>
                    )}
                    {wednesdayWork && (
                        <Stack direction="row" alignItems="center" spacing={2} pt={1} pb={1}>
                            <ItemTitle>Wednesday</ItemTitle>
                            <TimePicker
                                label="From"
                                value={new Date(`01/01/2017 ${wednesday.from}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setWednesday((prevState) => ({
                                        ...prevState,
                                        from: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        wednesday: {
                                            from: format(new Date(newValue), "HH:mm"),
                                            to: wednesday.to,
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                            <TimePicker
                                label="To"
                                value={new Date(`01/01/2017 ${wednesday.to}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setWednesday((prevState) => ({
                                        ...prevState,
                                        to: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        wednesday: {
                                            from: wednesday.from,
                                            to: format(new Date(newValue), "HH:mm"),
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                        </Stack>
                    )}
                    {thursdayWork && (
                        <Stack direction="row" alignItems="center" spacing={2} pt={1} pb={1}>
                            <ItemTitle>Thursday</ItemTitle>
                            <TimePicker
                                label="From"
                                value={new Date(`01/01/2017 ${thursday.from}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setThursday((prevState) => ({
                                        ...prevState,
                                        from: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        thursday: {
                                            from: format(new Date(newValue), "HH:mm"),
                                            to: thursday.to,
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                            <TimePicker
                                label="To"
                                value={new Date(`01/01/2017 ${thursday.to}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setThursday((prevState) => ({
                                        ...prevState,
                                        to: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        thursday: {
                                            from: thursday.from,
                                            to: format(new Date(newValue), "HH:mm"),
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                        </Stack>
                    )}
                    {fridayWork && (
                        <Stack direction="row" alignItems="center" spacing={2} pt={1} pb={1}>
                            <ItemTitle>Friday</ItemTitle>
                            <TimePicker
                                label="From"
                                value={new Date(`01/01/2017 ${friday.from}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setFriday((prevState) => ({
                                        ...prevState,
                                        from: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        friday: {
                                            from: format(new Date(newValue), "HH:mm"),
                                            to: friday.to,
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                            <TimePicker
                                label="To"
                                value={new Date(`01/01/2017 ${friday.to}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setFriday((prevState) => ({
                                        ...prevState,
                                        to: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        friday: {
                                            from: friday.from,
                                            to: format(new Date(newValue), "HH:mm"),
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                        </Stack>
                    )}
                    {saturdayWork && (
                        <Stack direction="row" alignItems="center" spacing={2} pt={1} pb={1}>
                            <ItemTitle>Saturday</ItemTitle>
                            <TimePicker
                                label="From"
                                value={new Date(`01/01/2017 ${saturday.from}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setSaturday((prevState) => ({
                                        ...prevState,
                                        from: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        saturday: {
                                            from: format(new Date(newValue), "HH:mm"),
                                            to: saturday.to,
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                            <TimePicker
                                label="To"
                                value={new Date(`01/01/2017 ${saturday.to}:00`)}
                                minutesStep={30}
                                onChange={(newValue) => {
                                    setSaturday((prevState) => ({
                                        ...prevState,
                                        to: format(new Date(newValue), "HH:mm"),
                                    }));
                                    setChanges((prevState) => ({
                                        ...prevState,
                                        enabled: true,
                                        saturday: {
                                            from: sunday.from,
                                            to: format(new Date(newValue), "HH:mm"),
                                        },
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" onKeyDown={onKeyDown} {...params} />
                                )}
                            />
                        </Stack>
                    )}
                </LocalizationProvider>
            </Grid>
        </Grid>
    );
};

export default WorkingHoursInfo;
